import {PopperProps, Typography} from '@mui/material';
import {DlMuiPopper, useMuiAnchor} from '@wallaby-ui/core';
import React from 'react';

type Props = {
  /** The translated text; nothing is shown when empty. */
  title?: string;
  placement?: PopperProps['placement'];
  children: React.ReactElement;
};

/**
 * The app's dark hover tooltip on an alert control in place of the browser's native `title`, with no wrapper element so
 * the control keeps its place in a flex row. A press closes it, as every other tooltip of the app.
 */
export const AlertTitleTooltip: React.FC<Props> = (props) => {
  const {title, placement = 'top', children} = props;
  const hasTooltip = Boolean(title);
  const {mouseEventEnter, mouseEventLeave, open, anchorEl, forceCloseTooltip} = useMuiAnchor(hasTooltip);
  const child = React.Children.only(children);
  return (
    <>
      {React.cloneElement(child, {
        onMouseEnter: (event: React.MouseEvent<HTMLElement>) => {
          child.props.onMouseEnter?.(event);
          mouseEventEnter(event);
        },
        onMouseLeave: (event: React.MouseEvent<HTMLElement>) => {
          child.props.onMouseLeave?.(event);
          mouseEventLeave(event);
        },
        onMouseDown: (event: React.MouseEvent<HTMLElement>) => {
          child.props.onMouseDown?.(event);
          forceCloseTooltip();
        },
      })}
      <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open} placement={placement}>
        <Typography variant={'popper'}>{title}</Typography>
      </DlMuiPopper>
    </>
  );
};

AlertTitleTooltip.displayName = 'AlertTitleTooltip';
